import { useEffect, useState } from "react";
import axios from "axios";
import { FaChartLine } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BINS = [
  { key: "range_0_20", label: "0-20", colors: ["#34d399", "#86efac"] },
  { key: "range_21_40", label: "21-40", colors: ["#86efac", "#bbf7d0"] },
  { key: "range_41_60", label: "41-60", colors: ["#fde047", "#fef3c7"] },
  { key: "range_61_80", label: "61-80", colors: ["#fb923c", "#fed7aa"] },
  { key: "range_81_100", label: "81-100", colors: ["#c084fc", "#e9d5ff"] },
];

export default function DashboardPerformanceAnalytics() {
  const [allExams, setAllExams] = useState([]);
  const [selectedExamId, setSelectedExamId] = useState(null);
  const navigate = useNavigate();

  const selectedExam = allExams.find(
    e => e.exam_details.exam_id === selectedExamId
  );

  useEffect(() => {
    axios.get("/dashboard/percentagewise_exam_stats/", { withCredentials: true })
      .then(res => {
        const exams = res.data?.data || [];

        const sorted = [...exams].sort(
          (a, b) =>
            new Date(b.exam_details.exam_end_time) -
            new Date(a.exam_details.exam_end_time)
        );

        setAllExams(sorted);

        if (sorted.length > 0) {
          setSelectedExamId(sorted[0].exam_details.exam_id); // latest default
        }
      })
      .catch(err => console.error("Performance analytics error:", err));
  }, []);

  if (!selectedExam) return null;

  const { exam_details, exam_statistics, employee_position } = selectedExam;
  const distribution = exam_statistics?.percentage_distribution || {};
  const maxCount = Math.max(...BINS.map(b => distribution[b.key]?.count || 0), 1);

  return (
    <section className="emp-performance-chart-card">
      <div className="emp-chart-header">
        <h3>
          <FaChartLine className="emp-chart-icon" /> Performance Analytics
        </h3>

        <select
          className="emp-exam-dropdown"
          value={selectedExamId}
          onChange={(e) => setSelectedExamId(Number(e.target.value))}
        >
          {allExams.map(exam => (
            <option key={exam.exam_details.exam_id} value={exam.exam_details.exam_id}>
              {exam.exam_details.full_exam_title}
            </option>
          ))}
        </select>
      </div>

      <div className="emp-glossy-bar-chart-container">
        <div className="emp-glossy-bars">
          {BINS.map((bin, index) => {
            const value = distribution[bin.key]?.count || 0;
            const isUserRange = employee_position?.percentage_range === bin.label;

            return (
              <div key={index} className="emp-glossy-bar-wrapper">
                <div
                  className="emp-glossy-bar"
                  style={{
                    height: `${(value / maxCount) * 100}%`,
                    background: `linear-gradient(to top, ${bin.colors[0]}, ${bin.colors[1]})`,
                    outline: isUserRange ? "3px solid #2563eb" : "none"
                  }}
                >
                  <span className="emp-bar-value-label">{value}</span>
                </div>

                <span className="emp-bar-label">{bin.label}</span>
                {isUserRange && <span className="emp-graduation-cap">🎓</span>}
              </div>
            );
          })}
        </div>
      </div>

      <div className="emp-distribution-footer">
        <div className="emp-user-score-info">
          Your Score: <strong>{exam_details.employee_percentage}%</strong> ({employee_position.percentage_range})
        </div>
      </div>
    </section>
  );
}


